<app-common-form-container
  appAuthorization
  header="DeliveryEfficiencyForecasting.DeliveryEfficiencyAndForcastingParameters"
  [formGroup]="formGroup"
  [useParentForm]="false"
  [saveButtonText] ="'DeliveryEfficiencyForecasting.SaveButtonText'"
  (saveClick)="onSaveClicked()"
  (resetClick)="onResetClicked()"
>
  <form form-content [formGroup]="formGroup">
    <div class="row">
      <app-form-field *ngIf="isLocation"
                      fieldLabel="DeliveryEfficiencyForecasting.OverrideOrganizationAnalytics"
                      fieldId="overrideOrgAnalyticsFields"
                      fieldControlName="overrideOrgAnalyticsFields"
                      type="checkbox"
                      [formGroup]="formGroup"
                      [labelPosition]="'after'">
      </app-form-field>

      <app-form-field [formGroup]="formGroup"
                      fieldLabel="DeliveryEfficiencyForecasting.AverageDeliveryCost"
                      fieldId="averageDeliveryCost"
                      fieldControlName="averageDeliveryCost"
                      type="number"
                      [formState]="0"
                      [validatorOrOpts]="[Validators.required, Validators.min(0)]"
                      [prefix]="'General.Dlr'">
      </app-form-field>

      <app-form-field [formGroup]="formGroup"
                      fieldLabel="DeliveryEfficiencyForecasting.DeliveryEfficiencyTarget"
                      fieldId="deliveryEfficiencyTarget"
                      fieldControlName="deliveryEfficiencyTarget"
                      type="number"
                      [formState]="0"
                      [validatorOrOpts]="[Validators.required, Validators.min(0), Validators.max(100)]"
                      [suffix]="'General.Pct'">
      </app-form-field>

    </div>

    <div class="row">
      <div class="col-auto">
        <div class="row">
          <div class="col">
            <label class="top-label field-label">
              {{ 'DeliveryEfficiencyForecasting.ActiveDays' | translate }}
              <span class="walkme-anchor"
                    [attr.walkme-anchor]="
                'DeliveryEfficiencyForecasting.ActiveDays'
              "></span>
            </label>
          </div>
        </div>
        <mat-checkbox class="pr-2" formControlName="sunday">
          {{ 'Days.ShortSunday' | translate }}
        </mat-checkbox>
        <mat-checkbox class="pr-2" formControlName="monday">
          {{ 'Days.ShortMonday' | translate }}
        </mat-checkbox>
        <mat-checkbox class="pr-2" formControlName="tuesday">
          {{ 'Days.ShortTuesday' | translate }}
        </mat-checkbox>
        <mat-checkbox class="pr-2" formControlName="wednesday">
          {{ 'Days.ShortWednesday' | translate }}
        </mat-checkbox>
        <mat-checkbox class="pr-2" formControlName="thursday">
          {{ 'Days.ShortThursday' | translate }}
        </mat-checkbox>
        <mat-checkbox class="pr-2" formControlName="friday">
          {{ 'Days.ShortFriday' | translate }}
        </mat-checkbox>
        <mat-checkbox class="pr-5" formControlName="saturday">
          {{ 'Days.ShortSaturday' | translate }}
        </mat-checkbox>
      </div>
      <div class="border-left col d-flex center-vertically">
        <div class="row center-vertically">
          <div class="col-auto">
            {{ 'DeliveryEfficiencyForecasting.Select' | translate }}
          </div>
          <div class="col">
            <button class="mr-4"
                    mat-stroked-button
                    color="primary"
                    (click)="selectAllDays()">
              {{ 'DeliveryEfficiencyForecasting.All' | translate }}
            </button>
            <button class="mr-4"
                    mat-stroked-button
                    color="primary"
                    (click)="selectWeekdays()">
              {{ 'DeliveryEfficiencyForecasting.Weekdays' | translate }}
            </button>
            <button class=""
                    mat-stroked-button
                    color="primary"
                    (click)="selectWeekends()">
              {{ 'DeliveryEfficiencyForecasting.Weekends' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
</form>
</app-common-form-container>
